<template>
    <div class="">
        <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> My Account Settings </h1>
            <a href="javascript:void(0)" class="btn btn-primary float-right" v-on:click="submitForm"> Save Changes </a>
        </div>
        <div class="global-main">
            <div class="global-inner my-account-inner">
                <p class="mb-3"> Please edit the following inputs and press save changes to update changes. </p>
                <div class="update-profile">
                    <div class="form-group upload-img-inner">
                        <div class="user-image">
                            <div id="image-preview" class="user-image-holder"  :style="'background: url('+$global.aws_base_url+'/avatar/'+form.avatar+');'">
                                <input type="file" name="" id="image-upload" v-on:change="onImageChange"/>
                            </div>
                            <div class="user-images-detail">
                                <span class="size-hint"> ( 100 X 100 ) </span>
                                <label for="image-upload" class="btn btn-primary" id="image-label"> Change profile picture </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="label block-label">Name:  <em class="required">*</em> </label>
                    <input type="text" class="form-control" name="name" v-model="form.name" :class="{ 'is-invalid': form.errors.has('name') }" />
                    <has-error :form="form" field="name"></has-error>
                </div>
              <div class="form-group" v-if="form.walletID !== 'NA'">
                <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                <input type="text" disabled="" class="form-control" name="walletID" v-model="form.walletID" />
              </div>
                <div class="form-group">
                    <label class="label block-label"> Mobile Number  <em class="required">*</em> </label>
                    <input type="text" disabled="" class="form-control" name="mobile_no" v-model="form.mobile_no" />
                </div>
                <div class="form-group" v-if="form.iban !== 'NA'" style="display: none;">
                    <label class="label block-label"> IBAN  <em class="required">*</em> </label>
                    <input type="text" disabled="" class="form-control" name="email" v-model="form.iban" />
                </div>
                <div class="form-group">
                  <label class="label block-label"> Email Address  <em class="required">*</em> </label>
                  <input type="text" disabled="" class="form-control" name="email" v-model="form.email" />
                </div>
                <button class="btn btn-primary click-change-password" @click="showInputs" v-if="is_show_btn == true"> Click To Change Password </button>
                <div class="change-password" v-if="is_show_inputs == true">
                    <div class="form-group">
                        <label class="label block-label"> Current Password  </label>
                        <input type="password" class="form-control" name="current_password" v-model="current_password" :class="{ 'is-invalid': form.errors.has('current_password') }" />
                        <has-error :form="form" field="current_password"></has-error>
                    </div>
                    <div class="form-group">
                        <label class="label block-label"> New Password  </label>
                        <input type="password" class="form-control" name="password" v-model="password" :class="{ 'is-invalid': form.errors.has('password') }" />
                        <has-error :form="form" field="password"></has-error>
                    </div>
                    <div class="form-group">
                        <label class="label block-label"> Re-type New Password </label>
                        <input type="password" class="form-control" name="password_confirmation" v-model="password_confirmation" />
                        <has-error :form="form" field="password_confirmation"></has-error>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                current_password: '',
                password: '',
                password_confirmation: '',
                form: new Form({
                name:'',
                mobile_no:'',
                walletID:'',
                avatar: '',
                email: '',
                current_password: '',
                password: '',
                password_confirmation: '',
                iban: '',
                }),
                is_show_btn : true,
                is_va: '',
                iban: '',
                is_show_inputs : false
            };
        },
        methods: {
            getUserDetails(){
                this.$Progress.start();
                axios.get('/api/getUserSettingsData')
                    .then(res => {
                        if(res.status == 200){
                            this.form.name = res.data.user.name;
                            this.form.avatar = res.data.user.avatar;
                            this.form.mobile_no = res.data.user.mobile_no;
                            this.form.email = res.data.user.email;
                            this.form.walletID = res.data.companyWalletID;
                            this.is_va = res.data.is_va;
                            this.form.iban = res.data.iban;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load data');
                        }
                    }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            submitForm(){
                this.$Progress.start();
                this.form.current_password = btoa(this.current_password);
                this.form.password = btoa(this.password);
                this.form.password_confirmation = btoa(this.password_confirmation);
                
                this.form.post('/api/updateUserSettings')
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                this.showToastBox('success', 'User Profile updated successfully');
                                this.$Progress.finish();
                            }else{
                                this.showAlertBox('error', res.data.msg);
                                this.$Progress.finish();
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in you form data');
                        }
                    }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in you form data');
                    });
            },
            onImageChange(e){
                if(e.target.files[0] == undefined)
                {
                    return;
                }
                this.form.avatar = e.target.files[0];
                this.uploadImage(e);
            },
            uploadImage(e) {
                e.preventDefault();
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                formData.append('avatar', this.form.avatar);
                axios.post('api/updateProfileImage', formData, config)
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == 200){
                                this.form.avatar = res.data.avatar;
                                console.log(this.$global.aws_base_url+'/avatar/'+this.form.avatar);
                                $('#user-profile-img').attr('src',this.$global.aws_base_url+'/avatar/'+this.form.avatar);
                                this.showToastBox('success', 'Profile Image updated successfully');
                                this.$Progress.finish();
                            }else{
                                this.$Progress.fail();
                                this.showAlertBox('error','Error to update Image');
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in you form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in you form data');
                                if (err.response) {
                                    // Request made and server responded
                                    console.log(err.response.data);
                                    console.log(err.response.status);
                                    console.log(err.response.headers);
                                } else if (err.request) {
                                    // The request was made but no response was received
                                    console.log(err.request);
                                } else {
                                    // Something happened in setting up the request that triggered an Error
                                    console.log('Error', err.message);
                                }
                    });
            },
            showInputs(){
                this.is_show_btn = false;
                this.is_show_inputs = true;
            },
        },
        mounted() {

        },
        created() {
            this.getUserDetails();
        },
         watch: {
			password: function() {
				//do something when the data changes.
                this.password=this.password.replace(/\s/g, "");
					this.password=this.password;
			}
         }
    }
</script>
